import api from "./api";

class AclAPI {


  async getPerfis(headers, params){

    const response = await api.get("/getPerfis", {headers, params});
    return response;
  }

  async getModulos(headers){

    const response = await api.get("/getModulos", {headers});
    return response;
  }

  async addModulo(headers, params){
    const response = await api({
      method: 'post',
      url: '/addModulo',
      headers,
      data:params
    });
    return response;
  }


  async delModulo(headers, params){
    const response = await api({
      method: 'delete',
      url: '/delModulo',
      headers,
      data:params
    });
    return response;
  }


  async addPerfil(headers, params){
    const response = await api({
      method: 'post',
      url: '/addPerfil',
      headers,
      data:params
    });
    return response;
  }


  async delPerfil(headers, params){
    const response = await api({
      method: 'delete',
      url: '/delPerfil',
      headers,
      data:params
    });
    return response;
  }

  async getAplicativos(headers){

    const response = await api.get("/getAplicativos", {headers});
    return response;
  }

  async getAplicativosModulos(headers){

    const response = await api.get("/get_aplicativos_modulos", {headers});
    return response;
  }

  async addAplicativo(headers, params){
    const response = await api({
      method: 'post',
      url: '/addAplicativo',
      headers,
      data:params
    });
    return response;
  }


  async delAplicativo(headers, params){
    const response = await api({
      method: 'delete',
      url: '/delAplicativo',
      headers,
      data:params
    });
    return response;
  }


  async getPermissoes(headers, params){

    const response = await api.get("/getPermissoes", {headers, params});
    return response;
  }

  async addPermissao(headers, params){
    const response = await api({
      method: 'post',
      url: '/addPermissao',
      headers,
      data:params
    });
    return response;
  }


  async delPermissao(headers, params){
    const response = await api({
      method: 'delete',
      url: '/delPermissao',
      headers,
      data:params
    });
    return response;
  }

  async getPermissoesPerfil(headers, params){

    const response = await api.get("/get_permissoes_perfil", {headers, params});
    return response;
  }

  async setAplicativoPerfil(headers, params){
    const response = await api({
      method: 'post',
      url: '/set_aplicativo_perfil',
      headers,
      data:params
    });
    return response;
  }

  async getPainelAdm(headers) {
    const response = await api.get("/get_painel_adm", { headers });
    return response;
  }

}

export default new AclAPI();
